import { Link } from "react-router-dom";
import Tag from "../../Tag";

const RelatedPostItem = ({ blog }) => {
    const { id, title, image, tags, createdAt } = blog || {};

    return (
        <div className="card">
            <Link to={`/post/${id}`}>
                <img src={image} className="card-image" alt={title} />
            </Link>
            <div className="p-4">
                <Link
                    to={`/post/${id}`}
                    className="text-lg post-title lws-RelatedPostTitle"
                >
                    {title}
                </Link>
                <div className="mb-0 tags">
                    {tags?.map((tag, i) => (
                        <Tag
                            key={i}
                            tag={tag}
                            index={i}
                            length={tags?.length}
                        />
                    ))}
                </div>
                <p>{createdAt}</p>
            </div>
        </div>
    );
};

export default RelatedPostItem;
